import React, { useContext } from 'react';
import { Link } from 'react-router-dom';
import { AuthContext } from '../../../../contex/AuthProvider';

const NavBar = () => {
    const { user, loOut } = useContext(AuthContext);
    const handlelogOut = () => {
        loOut()
            .then(() => { })
            .catch(err => console.error(err));
    }
    const menuItems = <>
        <li><Link to='/' className='rounded font-semibold'>Home</Link></li>
        <li><Link to='/block' className='rounded font-semibold'>Block</Link></li>

        {
            user?.uid ?
                <>
                    <li><Link to='/dashboard' className='rounded font-semibold'>Dashboard</Link></li>
                    <li><Link to='/login' onClick={handlelogOut} className=' btn text-white rounded font-semibold'>Log Out</Link></li>
                </>
                :
                <>
                    <li><Link to='/login' className='rounded font-semibold'>Log In</Link></li>
                    <li><Link to='/signup' className='rounded font-semibold'>Sign Up</Link></li>

                </>
        }
    </>

    return (
        <div className="navbar bg-light mt-2">
            <div className="navbar-start">
                <div className="dropdown">
                    <label tabIndex={0} className="btn btn-ghost lg:hidden">
                        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
                    </label>
                    <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-base-100 rounded-box w-52">
                        {menuItems}
                    </ul>
                </div>
                <Link to='/' className="btn btn-ghost normal-case text-3xl font-bold bg-white sad" >Book Bazer</Link>
            </div>
            <div className="navbar-center hidden lg:flex">
                <ul className="menu menu-horizontal p-0">
                    {menuItems}
                </ul>
            </div>
            <label htmlFor="dashboard-drawer" tabIndex={2} className="btn btn-ghost lg:hidden ml-12">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h8m-8 6h16" /></svg>
            </label>

        </div>
    );
};

export default NavBar;